



























































































import { EventStatus, EventType } from "@/models/event";
import { required } from "@/utils/validation";
import { Component, Vue, Watch } from "vue-property-decorator";
import { auth } from "@/store/modules";
import DependencyIdentifiers from "@/ioc/DependencyIdentifiers";
import { inject } from 'inversify-props';
import { ConstantDescriber, IDoctorService, IPatientService, IStockService } from "@/interfaces/Services";
import { DoctorModel } from "@/models/doctor";
import { PatientModel } from "@/models/patient";
import { DateInput } from '@/components/inputs';
import Bleeding from "@/components/EventDetail/Bleeding.vue";
import Operation from "@/components/EventDetail/Operation.vue";
import Injection from "@/components/EventDetail/Injection.vue";
import Inspection from "@/components/EventDetail/Inspection.vue";
import MissedInjection from "@/components/EventDetail/MissedInjection.vue";
import Physiotherapy from "@/components/EventDetail/Physiotherapy.vue";
import Note from "@/components/EventDetail/Note.vue";
import Sport from "@/components/EventDetail/Sport.vue";
import Visit from "@/components/EventDetail/Visit.vue";
import { StockItemStatsModel } from "@/models/stock";

@Component({components: {
  Bleeding,
  Operation,
  Injection,
  Inspection,
  MissedInjection,
  Physiotherapy,
  Note,
  Sport,
  Visit,
  DateInput,
}})
export class EventCreate extends Vue {
  @inject(DependencyIdentifiers.PatientService)
  private patientService!: IPatientService;
  @inject(DependencyIdentifiers.DoctorService)
  private doctorService!: IDoctorService;
  @inject(DependencyIdentifiers.StockService)
  private stockService!: IStockService;

  private doctors: DoctorModel[] = [];
  private patients: PatientModel[] = [];
  private consts!: ConstantDescriber;
  isLoading = false;
  patientStock: StockItemStatsModel[] = [];
  EventType = EventType;
  
  private formData = {
    type: EventType.Note,
    status: EventStatus.Draft,
    occuredAt: new Date(),
    $patientId: "",
    $doctorId: auth.authDoctorId!,
    $centerId: auth.currentCenterId!,
    comment: "",
    isOnTime: false,
    meta: {},
  };
  
  private get formConfig() {
    return {
      type: {
        label: this.$t('event.fields.type'),
        rules: [required],
        items: Object.entries(EventType).map(
          ([key, value]) => ({ text: this.$t(`event.values.eventType.${value}`), value })
        )
      },
      $patientId: {
        label: this.$t('event.fields.patientName'),
        rules: [required],
        items: this.patients.map(
          (patient) => ({ text: patient.name, value: patient.$id })
        )
      },
      $doctorId: {
        label: this.$t('event.fields.doctorName'),
        rules: [required],
        items: this.doctors.map(
          (doctor) => ({ text: doctor.name, value: doctor.$id })
        )
      },
      comment: {
        label: this.$t('event.fields.doctorComment'),
      },
      status: {
        label: this.$t('event.fields.status'),
        rules: [required],
        items: Object.entries(EventStatus).map(
          ([key, value]) => ({ text: this.$t(`event.status.${value}`), value })
        )
      },
      isOnTime: {
        label: this.$t('event.fields.isOnTime')
      },
      occuredAt: {
        label: this.$t('event.fields.occuredAt')
      }
    };
  }

  async mounted() {
    await this.loadDoctors();
    await this.loadPatients();
  }

  private async loadDoctors() {
    try {
      const page = 1,
        itemsPerPage = 100;
      const [doctors, {}] = await this.doctorService.getMany(
        page,
        itemsPerPage
      );
      this.doctors = [...doctors];
    } finally {
      this.isLoading = false;
    }
  }

  private async loadPatients() {
    try {
      const page = 1,
        itemsPerPage = 100;
      const [patients, {}] = await this.patientService.getMany(
        page,
        itemsPerPage
      );
      this.patients = [...patients];
    } finally {
      this.isLoading = false;
    }
  }

  @Watch('formData.type')
  onTypeChange(val: EventType, prev: EventType) {
    if (val != prev) { this.updateMeta(); }
  }

  @Watch('formData.patientId')
  async onPatientIdChange(val: string, prev: string) {
    if (val != prev) { await this.reloadPatientStock(); }
  }

  onOccuredAtChanged(val: string) {
    this.formData.occuredAt = new Date(val);
  }

  private updateMeta() {
    let meta = this.formData.meta;
    switch (this.formData.type) {
      case EventType.Injection:
        meta = {
          reason: ''
        };
        break;
      case EventType.Physiotherapy:
        meta = {
          hjhs: '',
          hjhsTotal: 0,
          physiotherapist: '',
          physiotherapistComment: '',
        };
        break;
      case EventType.Operation:
        meta = {
            type: '',
            establishment: '',
            department: '',
            doctorName: '',
            doctorComment: '',
            complications: '',
        };
        break;
      case EventType.Sport:
        meta = {
          type: '',
          duration: 0,
          intensity: 0,
        };
        break;
      case EventType.Bleeding:
        meta = {
            intensity: 0,
            type: null,
            reason: null,
            customType: '',
            customReason: '',
            bodyArea: {
              side: null,
              area: null,
            }
        };
        break;
      case EventType.Inspection:
        meta = {
          type: null,
          customType: ''
        };
        break;
      case EventType.Note:
      case EventType.MissedInjection:
      case EventType.Visit:
      default:
        meta = {};
        break;
    }

    this.formData.meta = meta;
  }

  private async reloadPatientStock() {
    this.patientStock = [];
    if (!!this.formData.$patientId) { return; }

    this.isLoading = true;
    try {
      const [items, total] = await this.stockService.stats(1, 100, {patientId: this.formData.$patientId});
      this.patientStock = [...items];
    } finally {
      this.isLoading = false;
    }
  }
}

export default EventCreate;
